/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { connect } from 'react-redux';
import useWindowSize from '../../hooks/useWindowSize';

// import Title from '../partials/Title';
import EventCard from '../partials/EventCard';
import EventCredits from '../partials/EventCredits';

import Borders from '../partials/Borders';
import Blocks from '../blocks/Blocks';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/event.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const EventPage = ({ page }) => {
    const smallScreen = useWindowSize().width < 1200;

    return (
        <div className={styles.container}>
            {!smallScreen ? (
                <div className={styles.credits}>
                    <EventCredits id={page.id} text={page.creditsText} credits={page.credits} />
                </div>
            ) : null}
            <Borders
                seed={page.id}
                borders={{
                    top: true,
                    right: false,
                    bottom: true,
                    left: true,
                }}
                className={styles.borders}
            >
                <div className={styles.content}>
                    <div className={styles.event}>
                        <EventCard {...page} format="page" withLink={false} withPatch />
                    </div>
                    {smallScreen ? (
                        <div className={styles.credits}>
                            <EventCredits
                                id={page.id}
                                text={page.creditsText}
                                credits={page.credits}
                            />
                        </div>
                    ) : null}
                    <div className={styles.blocks}>
                        <Blocks blocks={page.blocks} />
                    </div>
                </div>
            </Borders>
        </div>
    );
};

EventPage.propTypes = propTypes;

const WithStateContainer = connect(({ site: { color } }) => ({
    color,
}))(EventPage);

export default WithStateContainer;
